class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.cartCount = document.querySelector('[data-cart-count]');
    this.submitButton = this.querySelector('[type="submit"]');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();

    // Disable submit button and show adding state
    this.submitButton.setAttribute('disabled', true);
    this.submitButton.classList.add('loading');
    this.submitButton.textContent = this.submitButton.dataset.adding;

    // Get the form data
    const formData = new FormData(this.form);

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        const variantId = formData.get('id');
        const selectedVariant = Array.from(
          document.querySelectorAll('variant-selects input[type="radio"]')
        ).find((variant) => variant.value === variantId);

        // Update cart count
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cartData = await cartResponse.json();

        if (this.cartCount) {
          this.cartCount.textContent = cartData.item_count;
        }

        // Notify listeners that an item has been added to the cart
        window.dispatchEvent(
          new CustomEvent('cart:item-added', {
            detail: {
              lineItem: data,
              cart: cartData,
              compareAtPrice: Number(selectedVariant?.dataset.compareAtPrice || 0)
            }
          })
        );

        // Show success message using data attribute
        this.submitButton.textContent = this.submitButton.dataset.added;
        this.submitButton.classList.add('!bg-[#193029]', '!text-white');

        setTimeout(() => {
          this.submitButton.textContent = this.submitButton.dataset.available;
          this.submitButton.classList.remove('!bg-[#193029]', '!text-white');

          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('disabled');
        }, 2000);
      } else {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('disabled');

        throw new Error(data.description || 'Error adding item to cart');
      }
    } catch (error) {
      console.error('Error:', error);
      this.submitButton.textContent = this.submitButton.dataset.error;
    }
  }
}

customElements.define('product-form', ProductForm);
